<app-moniepoint-dialog [icon]="iconRef">
  <div class="modal">
    <div class="text-center mb-[10px]">
      <div class="title mt-[24px]">
        Decline Request
      </div>
      <div>
        Please provide reason(s) for rejection.
      </div>
    </div>
    <div  [formGroup]="form" nz-row class="flex w-full justify-evenly">
      <nz-form-control [nzSpan]="24" nzErrorTip="Reason is required!">
        <textarea nz-input formControlName="desc" placeholder="Description" rows="5" maxlength="250"></textarea>
      </nz-form-control>
    </div>

    <div class="my-6" *ngIf="errorMessage">
      <app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>
    </div>

    <div class="border border-[#0361F0] mt-[41px] opacity-[0.17] mb-6"></div>

    <div class="flex items-center -mx-[7.5px]">
      <div class="w-6/12 px-[7.5px]">
        <app-custom-button [isBlock]="true" text="Close" type="link" (click)="modal.destroy()">
        </app-custom-button>
      </div>

      <div class="w-6/12 px-[7.5px]">
        <app-custom-button [isBlock]="true" [isSubmitting]="isLoading === true" (click)="submitEvent()"
          text="Decline Request" state="warning" >
        </app-custom-button>
      </div>
    </div>
  </div>
</app-moniepoint-dialog>

<ng-template #iconRef>
  <svg width="73" height="73" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_13622_14883)">
      <circle cx="36.5" cy="36.5" r="36.5" fill="#E94444" fill-opacity="0.1" />
      <circle cx="36.5" cy="36.5" r="22.5" fill="#E94444" />
      <path
        d="M45.6 36.3999C45.6 37.394 44.7942 38.1999 43.8 38.1999C42.8059 38.1999 42 37.394 42 36.3999V29.1999C42 28.2058 42.8059 27.3999 43.8 27.3999C44.7942 27.3999 45.6 28.2058 45.6 29.1999V36.3999Z"
        fill="white" />
      <path
        d="M40.8 36.5999V30.0832C40.8 29.1741 40.2864 28.3431 39.4734 27.9366L39.4135 27.9067C38.747 27.5734 38.0121 27.3999 37.2669 27.3999L30.7676 27.3999C29.6235 27.3999 28.6385 28.2074 28.4142 29.3292L26.9742 36.5292C26.6772 38.0143 27.8131 39.3999 29.3276 39.3999H33.6V44.1999C33.6 45.5254 34.6746 46.5999 36 46.5999C36.6628 46.5999 37.2 46.0626 37.2 45.3999V44.5999C37.2 43.5613 37.5369 42.5508 38.16 41.7199L39.84 39.4799C40.4632 38.649 40.8 37.6385 40.8 36.5999Z"
        fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_13622_14883">
        <rect width="73" height="73" fill="white" />
      </clipPath>
    </defs>
  </svg>

</ng-template>